var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _circle4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 73.4C9.655 73.4 7.8194 72.6369 6.2932 71.1107C4.767 69.5845 4.0026 67.7476 4 65.6V18.8C4 16.655 4.7644 14.8194 6.2932 13.2932C7.822 11.767 9.6576 11.0026 11.8 11H74.2C76.345 11 78.1819 11.7644 79.7107 13.2932C81.2395 14.822 82.0026 16.6576 82 18.8V65.6C82 67.745 81.2369 69.5819 79.7107 71.1107C78.1845 72.6395 76.3476 73.4026 74.2 73.4H11.8ZM11.8 65.6H74.2V26.6H11.8V65.6Z",
    fill: "url(#paint0_linear_44_5262)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2963,
    cy: 19.4232,
    r: 2.808,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6557,
    cy: 19.4232,
    r: 2.808,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.2727,
    cy: 70.2727,
    r: 27.2727,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1969 59.0128H78.4418V58.4153C78.4418 55.9807 76.461 54 74.0264 54H69.9724C67.5378 54 65.557 55.9807 65.557 58.4154V59.0128H62.8019C60.5795 59.0128 58.7715 60.8209 58.7715 63.0433V65.4277C58.7715 66.1181 59.3311 66.6777 60.0215 66.6777H60.5314L61.483 81.3242C61.6534 83.9461 63.845 86 66.4725 86H77.5263C78.7902 86 79.9968 85.5271 80.924 84.6682C81.8504 83.8101 82.414 82.6446 82.5114 81.3862C82.5646 80.6979 82.0497 80.0968 81.3614 80.0436C80.6733 79.9896 80.072 80.5053 80.0188 81.1935C79.9188 82.4869 78.824 83.5 77.5264 83.5H66.4725C65.1587 83.5 64.0629 82.4731 63.9777 81.1621L63.0367 66.6777H80.962L80.424 74.9589C80.3793 75.6478 80.9015 76.2426 81.5904 76.2873C82.2799 76.3321 82.874 75.8099 82.9188 75.121L83.4674 66.6777H83.9773C84.6677 66.6777 85.2273 66.1181 85.2273 65.4277V63.0433C85.2273 60.8208 83.4193 59.0128 81.1969 59.0128ZM68.057 58.4154C68.057 57.3592 68.9163 56.5 69.9724 56.5H74.0264C75.0825 56.5 75.9418 57.3592 75.9418 58.4154V59.0128H68.057V58.4154ZM61.2715 64.1777V63.0433C61.2715 62.1994 61.9581 61.5128 62.802 61.5128H81.1969C82.0408 61.5128 82.7274 62.1994 82.7274 63.0433V64.1777H61.2715Z",
    fill: "#DD2025"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.877 71.1445V78.102C67.877 78.7923 68.4366 79.352 69.127 79.352C69.8173 79.352 70.377 78.7923 70.377 78.102V71.1445C70.377 70.4542 69.8173 69.8945 69.127 69.8945C68.4366 69.8945 67.877 70.4542 67.877 71.1445Z",
    fill: "#DD2025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6211 71.1445V78.102C73.6211 78.7923 74.1807 79.352 74.8711 79.352C75.5615 79.352 76.1211 78.7923 76.1211 78.102V71.1445C76.1211 70.4542 75.5615 69.8945 74.8711 69.8945C74.1807 69.8945 73.6211 70.4542 73.6211 71.1445Z",
    fill: "#DD2025"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.2727,
    cy: 70.2727,
    r: 27.2727,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_5262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 59H78.25V57.75C78.25 55.6823 76.5677 54 74.5 54H69.5C67.4323 54 65.75 55.6823 65.75 57.75V59H59.5C58.8096 59 58.25 59.5596 58.25 60.25C58.25 60.9404 58.8096 61.5 59.5 61.5C60.1892 61.5 60.75 62.0608 60.75 62.75V82.25C60.75 84.3177 62.4323 86 64.5 86H79.5C81.5677 86 83.25 84.3177 83.25 82.25V62.75C83.25 62.0608 83.8107 61.5 84.5 61.5C85.1904 61.5 85.75 60.9404 85.75 60.25C85.75 59.5596 85.1904 59 84.5 59ZM68.25 57.75C68.25 57.0608 68.8108 56.5 69.5 56.5H74.5C75.1893 56.5 75.75 57.0608 75.75 57.75V59H68.25V57.75ZM80.75 62.75V82.25C80.75 82.9393 80.1893 83.5 79.5 83.5H64.5C63.8108 83.5 63.25 82.9393 63.25 82.25V62.75C63.25 62.3118 63.1737 61.8913 63.035 61.5H80.9651C80.8263 61.8913 80.75 62.3118 80.75 62.75Z",
    fill: "#808690",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 64C66.3096 64 65.75 64.5596 65.75 65.25V79.75C65.75 80.4404 66.3096 81 67 81C67.6904 81 68.25 80.4404 68.25 79.75V65.25C68.25 64.5596 67.6904 64 67 64Z",
    fill: "#808690",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 64C71.3096 64 70.75 64.5596 70.75 65.25V79.75C70.75 80.4404 71.3096 81 72 81C72.6904 81 73.25 80.4404 73.25 79.75V65.25C73.25 64.5596 72.6904 64 72 64Z",
    fill: "#808690",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.75 65.25V79.75C75.75 80.4404 76.3096 81 77 81C77.6904 81 78.25 80.4404 78.25 79.75V65.25C78.25 64.5596 77.6904 64 77 64C76.3096 64 75.75 64.5596 75.75 65.25Z",
    fill: "#808690",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_5262",
    x1: 43,
    y1: 73.4,
    x2: 43,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#177BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_5262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(56 54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalDelete);
export default __webpack_public_path__ + "static/media/modal_delete.4e8d965f5ab794c1b69c8dc0167f6e02.svg";
export { ForwardRef as ReactComponent };